import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { ACADEMY_LOGO } from "../data/assets";
import { getUtm, getSid } from "../lib/utm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// One-tap resubscribe: if memberships are live, jump straight into Stripe checkout for the
// chosen tier; otherwise fall back to the membership tiers on the landing page.
export default function Subscribe() {
  const [params] = useSearchParams();
  const tier = (params.get("tier") || "elite").toLowerCase();
  const [msg, setMsg] = useState("Taking you to checkout…");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data: pricing } = await axios.get(`${API}/pricing`);
        if (!cancelled && pricing.memberships_open && (tier === "elite" || tier === "academy")) {
          const { data } = await axios.post(`${API}/payments/checkout`, { origin_url: window.location.origin, tier, utm: getUtm(), sid: getSid() });
          window.location.href = data.checkout_url;
          return;
        }
      } catch (e) { /* fall through to tiers */ }
      if (!cancelled) {
        setMsg("Taking you to enrollment options…");
        window.location.href = `/?tier=${tier === "academy" ? "academy" : "elite"}`;
      }
    })();
    return () => { cancelled = true; };
  }, [tier]);

  return (
    <div data-testid="subscribe-redirect" className="min-h-screen bg-[#0a0a0a] text-white flex flex-col items-center justify-center gap-5 px-6 text-center">
      <img src={ACADEMY_LOGO} alt="The Next O Technical Academy" className="w-44 h-auto object-contain" />
      <Loader2 size={28} className="animate-spin text-[#D4AF37]" />
      <p className="text-white/70 text-sm uppercase tracking-widest">{msg}</p>
    </div>
  );
}
